<template>
  <div>
    <pop-modal :visible="visible" :isDrag="true" title="库存查询" width="70%" :height="80" @cancel="handelCancel">
      <div class="header">
        <div>
          领取年份
          <select>
            <option value="全部">全部</option>
          </select>
        </div>
        <div>
          领购月份
          <select>
            <option value="all">全部</option>
            <option value="1">1月</option>
            <option value="2">2月</option>
            <option value="3">3月</option>
            <option value="4">4月</option>
            <option value="5">5月</option>
            <option value="6">6月</option>
            <option value="7">7月</option>
            <option value="8">8月</option>
            <option value="9">9月</option>
            <option value="10">10月</option>
            <option value="11">11月</option>
            <option value="12">12月</option>
          </select>
        </div>
        <div>
          发票种类
          <select>
            <option value="all">全部</option>
            <option value="all">增值税专用发票</option>
            <option value="all">增值税普通发票</option>
          </select>
        </div>
        <a-button type="primary"> 查询 </a-button>
        <a-button type="primary" ghost> 导出 </a-button>
      </div>
      <m-table
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :columns="columns"
        :data-source="fpData"
      ></m-table>
      <div v-for="(item, i) in columns" :key="i">{{ item.filter ? item.filter(1) : '' }}</div>
    </pop-modal>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util'
export default {
  data() {
    return {
      visible: false,
      pagination: false,
      selectedRowKeys: [],
      columns: [
        {
          title: '发票种类',
          dataIndex: 'taxClass',
          width: 100,
          customRender: (v) => {
            return v === '0' ? '专用发票' : v === '1' ? '普通发票' : '电子普通发票'
          },
        },
        {
          title: '开票限额',
          dataIndex: 'invoiceQuota',
          width: 100,
        },
        {
          title: '发票代码',
          dataIndex: 'taxBillCode',
          width: 100,
        },
        {
          title: '起始号码',
          dataIndex: 'taxBillSurNoStart',
          width: 100,
        },
        {
          title: '终止号码',
          dataIndex: 'taxBillNoEnd',
          width: 100,
        },
        {
          title: '库存份数',
          dataIndex: 'taxBillsurNum',
          width: 100,
        },
        {
          title: '领购份数',
          dataIndex: 'taxBillBuyNum',
          width: 100,
        },
        {
          title: '领购时间',
          dataIndex: 'taxBillBuyDate',
          width: 100,
        },
      ],
      fpData: [],
      domainName: '',
      searchFp: false,
      isShow: false,
      drID: '',
    }
  },
  methods: {
    show() {
      this.getIcManageList(1)
    },
    /**
     * 发票读入/库存查询退回接口   writeToIC为0表示读入发票
     */
    async getIcManageList(writeToIC) {
      const params = parseParam({
        isWriteToIC: writeToIC,
      })
      const res = await this.$http.post(`${Urls.getIcManageList}&${params}`)
      if (res) {
        this.fpData = res.data
        this.domainName = res.domainName
        this.visible = true
      }
    },
    handelCancel() {
      this.visible = false
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
      this.drID = this.selectedRowKeys[0].id
    },
  },
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px;
}
</style>
